import { NavLink } from 'react-router-dom';
import AnimatedLogo from './AnimatedLogo';

const links = [
  { to: '/', label: 'Inicio', end: true },
  { to: '/carta', label: 'Carta' },
  { to: '/eventos', label: 'Eventos' },
  { to: '/contacto', label: 'Contacto' },
];

export default function Navbar() {
  return (
    <nav className="neon-nav">
      <NavLink to="/" className="neon-nav-brand">
        <AnimatedLogo className="neon-nav-symbol neon-nav-logo-animated" />
      </NavLink>

      <div className="neon-nav-links">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) => `neon-nav-link${isActive ? ' active' : ''}`}
          >
            <span>{link.label}</span>
          </NavLink>
        ))}
        <a
          href="https://wa.me/34614807628?text=Hola!%20Quiero%20reservar%20en%20NEÖN"
          target="_blank"
          rel="noreferrer"
          className="neon-nav-link neon-nav-reservar"
        >
          <span>Reservar</span>
        </a>
      </div>
    </nav>
  );
}
